import {
  OperatorExactlyAllOf,
  OperatorExactlyAnyOf,
} from 'v2/core/services/queryBuilder/operators';

const checkIsExactSearchOperator = (operator: string): boolean =>
  operator === OperatorExactlyAllOf || operator === OperatorExactlyAnyOf;

export default checkIsExactSearchOperator;
